module.exports = __webpack_public_path__ + "img/history.032e73bd.png";